/**
 * 服务端ajax,基类
 */
import login from './login';
import clientType from './clientType';
import { messages } from './../config';
import { getCookie } from '@/util/common';

import Vue from 'vue';

const vm = new Vue();
const errorMsg = messages.error;
const noAuthMsg = messages.noAuth;
let jda = getCookie('_jda');
let jda1 = '';
try {
  jda1 = jda.split('.')[1] || '';
} catch (error) {
  console.log(error);
}

/**
 * 加工参数
 * @param {接口参数} reqData
 * @param {原入参} originalOpt
 */
function _defaultSendData(reqData, originalOpt) {
  const _reqData = {
    clientType: !originalOpt.isCustom ? clientType() : originalOpt.getClientType(),
    clientVersion: ($.device && $.device.clientVersion) || '',
    jda: jda1
  };

  $.extend(_reqData, reqData);
  // console.log(process.env.NODE_ENV);

  return _reqData;
}

/**
 * 过滤后台返回提示文案
 * @param {字符串} msg
 */
function _splitBySpace(msg) {
  let msgs = '';

  if ($.type(msg) === 'string') {
    msgs = msg.split(' ');
  }

  let rst = '';
  if (msgs && msgs.length > 0) {
    rst = $.trim(String(msgs[0]));
    return rst ? rst : errorMsg;
  }
  return msg;
}

/**
 * 去登录
 * @param {提示文案} msg
 * @param {原入参} originalOpt
 * @param {服务端返回} rstData
 */
function _login(msg, originalOpt, rstData) {
  // $.loading.hide();
  if ($.isFunction(originalOpt.error) && !originalOpt.enableError) {
    originalOpt.error(msg || noAuthMsg, rstData);
  } else {
    vm.$alert && vm.$alert.show({ title: msg || noAuthMsg });
    if (login) {
      login();
    }
  }
}

/**
 * 抛错
 * */
function _showError(opts) {
  const { msg, originalOpt, errorData } = opts;
  //isBack
  if (!originalOpt.unHideLoading) {
    vm.$nextTick(() => {
      vm.$loading && vm.$loading.hide();
    });
  }

  const _msg = _splitBySpace(msg);

  if ($.isFunction(originalOpt.error)) {
    originalOpt.error(_msg || errorMsg);
  } else if (originalOpt.enableError || !$.isFunction(originalOpt.error)) {
    vm.$nextTick(() => {
      vm.$alert && vm.$alert.show({ title: _msg || errorMsg });
    });
  }

  if (originalOpt.afterError && $.isFunction(originalOpt.afterError)) {
    originalOpt.afterError(_msg);
  }

  try {
    if (typeof window.errorReport === 'function') {
      window.errorReport({
        logLevel: originalOpt.logLevel || 'NORMAL',
        logData: `${originalOpt.url},[response]:${JSON.stringify(errorData)}`,
        errorFileName: 'request.js#83' || ''
      });
    }
  } catch (e) {
    console.log(e);
  }
}

const _request = {
  send(originalOpt) {
    let opt = null;
    const defaultOptions = {
      // 第几层级立即返回,默认0（不立即返回）
      // 1,网关接口层
      // 2,业务接口层
      resultLevel: 0,
      // 是否启动错误提示，默认true
      enableError: true,
      // 是否启动lonading，默认启动
      isShowLoading: true,
      // 错误回调
      error: null,
      // 成功回调
      success: $.emptyFun,
      // 发送请求之前调用方法
      beforeExtendOpt: null,
      // 接口参数对象
      data: null,
      // 接口url
      url: '',
      type: 'POST',
      dataType: 'JSON',
      contentType: 'text/plain;charset=UTF-8',
      timeout: 30000,
      /**
       * 跨域操作cookie
       * */
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      /**
       * 是否使用网关接口，默认启动
       * @type {Boolean}
       */
      isGateway: true,
      // 是否序列化接口参数，默认true
      isDataStringify: true
    };

    if (originalOpt) {
      if ($.isFunction(originalOpt.beforeExtendOpt)) {
        originalOpt.beforeExtendOpt(originalOpt);
      }

      opt = $.extend({}, defaultOptions, originalOpt);

      if (opt.isShowLoading) {
        // $.loading.show();
      }

      let data = _defaultSendData(opt.data, originalOpt);

      if (opt.isDataStringify) {
        data = JSON.stringify(data) || '';
      }

      if (opt.isGateway) {
        opt.data = {
          reqData: data
        };
        opt.contentType = originalOpt.contentType || 'application/x-www-form-urlencoded;charset=UTF-8';
      } else {
        opt.data = data;
      }

      //console.log(opt);
      // console.log('ajax data ->', opt.data);
      opt.success = function(data) {
        if (data) {
          if ($.type(data) === 'string') {
            data = $.parseJSON(data);
          }

          // 判断层级
          if (opt.resultLevel === 1) {
            originalOpt.success(data);
            return;
          }

          // console.log('ajax success ->', data);
          switch (String(data.resultCode)) {
            case '0':
              {
                //返回一级结果
                const rstData = data.resultData;
                if (opt.resultLevel === 2) {
                  originalOpt.success(data);
                  return;
                }

                if (rstData) {
                  switch (String(rstData.issuccess)) {
                    /**
                     * 成功
                     * */
                    case '1':
                      originalOpt.success(rstData);
                      break;
                    /**
                     * 未登录
                     * */
                    case '3':
                      _login(rstData.message, originalOpt, rstData);
                      break;
                    /**
                     * 2
                     * */
                    default:
                      _showError({ msg: rstData.error_msg, originalOpt, errorData: rstData });
                      break;
                  }
                }
              }
              break;
            case '3':
              _login(data.resultMsg, originalOpt, data);
              break;
            default:
              _showError({ msg: data.resultMsg, originalOpt, errorData: data });
              break;
          }
        } else {
          _showError({ msg: messages.noData, originalOpt, errorData: data });
        }
      };

      opt.error = function(xhr, type) {
        // console.log('ajax error->', xhr, type);
        _showError({ msg: messages.noNet, originalOpt, errorData: { type } });
      };

      return $.ajax(opt);
    }
  },
  /**
   * 注册URL
   * */
  register(key, options) {
    if (!key || !options) {
      return;
    }
    const url = options.url || key;
    const baseUrl = options.baseURL || $.config.baseURL;
    //console.log(options);
    _request[key] = function(options) {
      if (options && url) {
        options.url = baseUrl + url;
        return _request.send(options);
      }
    };

    _request[key].url = baseUrl + url;
  }
};

export default _request;
